<lib-layout [showBackground]="false">
  <div toolbar class="contents">
    <dges-logo
      matRipple
      routerLink="."
      [routerLink]="''"
      class="inline-block h-12 align-middle"
      prefix="d"
      accent="ღ"
      suffix="es"
    ></dges-logo>

    @if (showFullMenu) {
      <dges-full-length-menu [fillerNav]="fillerNav"></dges-full-length-menu>
    } @else {
      <dges-drop-down-menu [fillerNav]="fillerNav"></dges-drop-down-menu>
    }

    <div>
      @if (user$ | async; as user) {
        <button
          mat-button
          [matMenuTriggerFor]="menu"
          [attr.aria-label]="'Account menu for ' + user.displayName"
          >
          <span class="flex items-center gap-2">
            @if (user.photoURL) {
              <img
                [src]="user.photoURL"
                [alt]="user.displayName"
                referrerpolicy="no-referrer"
                class="size-8 rounded-full object-cover"
                />
            } @else {
              <mat-icon>account_circle</mat-icon>
            }
            <span>{{ user.displayName }}</span>
          </span>
        </button>
      } @else {
        <button (click)="openLogin()" mat-icon-button aria-label="Log in">
          <mat-icon>login</mat-icon>
        </button>
      }
    </div>
  </div>

  <router-outlet content></router-outlet>

  <ng-container footer>
    @if (user$ | async; as user) {
      <div
        class="flex h-16 flex-auto items-center justify-center"
        matRipple
        [matMenuTriggerFor]="menu"
        >
        @if (user.photoURL) {
          <img
            [src]="user.photoURL"
            [alt]="user.displayName"
            referrerpolicy="no-referrer"
            class="size-8 rounded-full object-cover"
            />
        } @else {
          <mat-icon>account_circle</mat-icon>
        }
      </div>
    } @else {
      <button (click)="openLogin()" mat-icon-button aria-label="Log in">
        <mat-icon>login</mat-icon>
      </button>
    }
    <div
      matRipple
      routerLink="."
      [routerLink]="'timeline'"
      class="flex h-16 flex-auto items-center justify-center"
      >
      <dges-logo
        class="inline-block h-12 align-middle"
        prefix="d"
        accent="ღ"
        suffix="es"
        [minimal]="true"
      ></dges-logo>
    </div>
    <div
      matRipple
      [matMenuTriggerFor]="routeMenu"
      class="flex h-16 flex-auto items-center justify-center"
      >
      <mat-icon>menu</mat-icon>
    </div>
  </ng-container>
</lib-layout>


<mat-menu #menu="matMenu">
  <button mat-menu-item disabled>
    <mat-icon>person</mat-icon>
    @if (user$ | async; as user) {
      <span>{{ user.email }}</span>
    }
  </button>
  <button mat-menu-item (click)="logout()">
    <mat-icon>undo</mat-icon>
    <span>Log out</span>
  </button>
</mat-menu>

<mat-menu #routeMenu="matMenu">
  @for (nav of fillerNav; track nav) {
    @if (!(((user$ | async) === null || (user$ | async) === undefined) && nav?.canActivate)) {
      <button
        mat-menu-item
        routerLink="."
        [routerLink]="nav.path"
        >
        {{ nav.path }}
      </button>
    }
  }
</mat-menu>
